import { createFileRoute } from "@tanstack/react-router";
import About from "@/pages/About";

const OG_IMAGE = "https://www.garden-review.co.uk/images/og-default.jpg";

export const Route = createFileRoute("/about")({
  head: () => ({
    meta: [
      { property: "og:image", content: OG_IMAGE },
      { property: "og:image:width", content: "1200" },
      { property: "og:image:height", content: "630" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:image", content: OG_IMAGE },
    ],
  }),
  component: About,
});
